import MyProcessListAPI from "./services/MyProcessListAPI";

var bindCustomDataList = {
    data: {},
    populateDataListData() {
        var self = this;
        this.data = {}
        $("*[dataListName]").each(function () {            
            self.fetchDataFromDataList(this);
        });
    },
    fetchDataFromDataList(ele) {
        var dataListName = $(ele).attr("dataListName");
        MyProcessListAPI.getDataFromDataList(dataListName).then(result => {
            if (result.type != null) {
                if (result.type == "manual") {
                    this.getDataForManualEntries(result, ele);
                } else {
                    this.getDataForEsysAdapter(result, ele);
                }
            }
        }).finally(() => {

        });
    },

    getDataForManualEntries(responseData, ele) {
        var dataEntries = responseData.dataEntries;
        var dataListName = $(ele).attr("dataListName");
        let optionData = []
        // this.data = [];
        var self = this;
        if (dataEntries != null) {
            $.each(dataEntries, function (key, value) {
                optionData.push({
                    "nameField": value.valueField,
                    "displayField": value.nameField + " - " + value.valueField,
                    "valueField": value.nameField
                });
            });
            $(ele).data("selectData", optionData);
            self.data[dataListName] = optionData
            this.populateDropdownWithData(ele, null,"MANUAL");
        }
    },

    getDataForEsysAdapter(responseData, ele) {

        var dataListName = $(ele).attr("dataListName");        
        var dataJson = JSON.parse(responseData.dataJson);
        var dataField = dataJson.dataField;
        var valueField = dataJson.valueField;
        var dispField = dataJson.dispField;
        var eSysUrl = dataJson.url;
        var obj = `?eSysUrl=${eSysUrl}&processInstanceId=`;
        var self = this;
        // MyProcessListAPI.getDataForEsysAdapter(obj).then(result => {
        //     eSysUrl = result;
            MyProcessListAPI.getDataListsFromAdapter(eSysUrl).then(result => {
                // console.log(result);
                if (dataField == null || dataField == "") {
                    dataField = "data";
                }
                if (dispField == null || dispField == "") {
                    dispField = "value";
                }
                if (valueField == null || valueField == "") {
                    valueField = "name";
                }

                if (result != null && result[dataField] != null) {
                    let optionData = []
                    // self.data = [];
                    $.each(result[dataField], function (i, infoData) {
                        if (infoData[dispField] && infoData[valueField]) {
                            optionData.push({
                                "nameField": infoData[valueField],
                                "valueField": infoData[dispField],
                                "displayField": infoData[valueField] + " - "
                                    + infoData[dispField]
                            });
                        }
                    });
                    $(ele).data("selectData", optionData);
                    self.data[dataListName] = optionData
                    self.populateDropdownWithData(ele, null, "ESYS");
                }
            }).finally(() => {

            });
        // }).finally(() => {

        // });
    },
    populateDropdownWithData(ele, externalData, type) {
        let arrayOptions = [];
        var dataListName = $(ele).attr("dataListName");
        if (ele.hasAttribute('adddefaultvalue') && $(ele).attr('adddefaultvalue') == 'true') {
            var option = {
                text: 'Select an option',
                placeholder: true,
                value: ''
            };
            arrayOptions.push(option);
        }
        
        let dataListArray = externalData == null ? this.data[dataListName] : externalData;
        $.each(dataListArray, function (i, infoData) {
            var option = {
                text: infoData.valueField,
                value: infoData.nameField
            };
            arrayOptions.push(option);
        });
        this.appendDataInDropdown(ele, arrayOptions, type);           
    },    
    appendDataInDropdown(ele, arrayOptions, type) {
        $(ele).html('');
        var defaultvalue = "";
        if (ele.hasAttribute('defaultValue') && $(ele).attr('defaultValue') != "") {
            defaultvalue = $(ele).attr('defaultValue');
        }

        if (arrayOptions.length > 0) {
            $.each(arrayOptions, function (i, data) {
                $(ele).append(`<option value="${data.value}">${data.text} ` + bindCustomDataList.getValueWithHyphen(data.value, type) + `</option>`)
            });
        } else {
            $(ele).append(`<option value="">Select an option</option>`)
        }

        setTimeout(() => {
            if (defaultvalue != "" && type !== 'ESYS') {
                if($(ele).attr("multiple") == "multiple") {
                    var checkedArray = defaultvalue.split(',');
                    $(ele)[0].slim.set(checkedArray);
                }
                else {
                    $(ele)[0].value = defaultvalue;
                }
            }
        }, 500);
    },
    getValueWithHyphen(value, type) {
        if(type === 'ESYS'){
            return value === "" ? "" : "- " + value;
        } else { 
            return "";
        }
    }
}

export default bindCustomDataList;